import React, {useEffect, useState} from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Wrapper, TextWrapper, Text, IUWrapper, SubText, ScrollDown, Mouse, Scroller } from './Carousel.elements';
import "./Fix.css"

const Carousel = (props) => {

  console.log(props);
  
    var settings = {
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      fade: true,
      cssEase: 'linear',
      autoplaySpeed: 4000,
      arrows: false,
      };

      return (
        <div style={{position: "relative"}}>
          <Slider {...settings}>
            {
              props.props.Slide.map(x => {
                return(
                <Wrapper background={x.Image}>
                    <TextWrapper>
                      <IUWrapper>
                        <Text>
                          {x.Title}
                        <SubText>
                          {x.Description}
                        </SubText>
                        </Text>
                      </IUWrapper>
                    </TextWrapper>
                  </Wrapper>
                )
              })
            }
          </Slider>
          <ScrollDown>
            <Mouse>
              <Scroller />
            </Mouse>
          </ScrollDown>

        </div>
      );
}

export default Carousel
